import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './Header.css';

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="app-title">DesignsDesigns</h1>
          <nav className="nav-links">
            {user?.role !== 'worker' && <a href="/" className="nav-link">Dashboard</a>}
            {user?.role !== 'worker' && <a href="/customers" className="nav-link">Customers</a>}
            {user?.role !== 'worker' && <a href="/jobs" className="nav-link">Jobs</a>}
            {user?.role !== 'worker' && <a href="/quotes" className="nav-link">Quotes</a>}
            <a href="/work-orders" className="nav-link">Work Orders</a>
            <a href="/shop-status" className="nav-link">Shop Status</a>
            {user?.role !== 'worker' && <a href="/inventory" className="nav-link">Inventory</a>}
            {user?.role !== 'worker' && <a href="/blueprints" className="nav-link">Blueprints</a>}
            {user?.role === 'admin' && <a href="/employees" className="nav-link">Employees</a>}
            {user?.role !== 'worker' && <a href="/settings" className="nav-link">Settings</a>}
            <a href="/documentation" className="nav-link">Docs</a>
          </nav>
        </div>
        <div className="header-right">
          <span className="user-email">{user?.username}</span>
          <button className="logout-btn" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      </div>
    </header>
  );
}
